
<div style="display: flex;justify-content: center;margin-top: 30px">
    <div style="width: 85%">
      <h2>Egreso de equiposw</h2>
  
      <h3>Producto: {{productName}}</h3>
      <h3>File: {{file?.fileNumber}}</h3>
<!--       <div *ngIf="!loading" style="display: flex;justify-content: center;margin-top: 1rem">
        <mat-form-field appearance="outline" class="divInputSearch">
          <mat-label>Filtrar</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
        </mat-form-field>
      </div> -->
  
      <div *ngIf="loading" class="spinner" >
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
  
  
        <div *ngIf="!loading" class="mat-elevation-z8 overflow">
          <table mat-table [dataSource]="dataSource">
  
            <ng-container matColumnDef="nombre" >
              <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
              <td mat-cell *matCellDef="let element">{{ element.agrupadoInfo.nombreEquipo }}</td>
            </ng-container>
  
            <ng-container matColumnDef="marca" >
              <th mat-header-cell *matHeaderCellDef>MARCA</th>
              <td mat-cell *matCellDef="let element">{{ element.agrupadoInfo.marcaEquipo }}</td>
            </ng-container>
  
            <ng-container matColumnDef="modelo" >
              <th mat-header-cell *matHeaderCellDef>MODELO</th>
              <td mat-cell *matCellDef="let element">{{ element.agrupadoInfo.modeloEquipo }}</td>
            </ng-container>

            <ng-container matColumnDef="talla" >
              <th mat-header-cell *matHeaderCellDef>TALLA</th>
              <td mat-cell *matCellDef="let element">{{ element.agrupadoInfo.tallaEquipo }}</td>
            </ng-container>
              
            <ng-container matColumnDef="equiposAsignados" >
              <th mat-header-cell *matHeaderCellDef>EQUIPOS ASIGNADOS</th>
              <td mat-cell *matCellDef="let element">{{ element.totalAssigned }}</td>
            </ng-container>
  
  
            <ng-container matColumnDef="editar">
              <th mat-header-cell *matHeaderCellDef> ASIGNAR EQUIPOS DE INVENTARIO</th>
              <td mat-cell *matCellDef="let element;let i=index">
                <button mat-icon-button color="primary" (click)="openDialogAsignarEquipo(element,i)">
                    <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>

  
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" ></tr>
  
          </table>
        </div>
        <div [hidden]="loading">
          <mat-paginator [pageSizeOptions]="[5, 15, 30, 100]"
                         showFirstLastButtons>
          </mat-paginator>
        </div> 
  
  
    </div>
  
  </div>
  
  
  
  
  